var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktop)?_c('v-navigation-drawer',{staticClass:"acc-nav-bar",attrs:{"right":!_vm.isRtl,"hide-overlay":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('nav-bar')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }